__webpack_require__.p = "/nanobyte/";